import { useState, useCallback } from 'react';

export interface AIMessage {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string;
  timestamp: Date;
  context?: Record<string, any>;
}

export function useAIOpsSession() {
  const [messages, setMessages] = useState<AIMessage[]>([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const addMessage = useCallback((role: 'user' | 'assistant' | 'system', content: string, context?: Record<string, any>) => {
    const newMessage: AIMessage = {
      id: `${Date.now()}-${Math.random()}`,
      role,
      content,
      timestamp: new Date(),
      context,
    };
    setMessages((prev) => [...prev, newMessage]);
    return newMessage;
  }, []);

  const clearHistory = useCallback(() => {
    setMessages([]);
  }, []);

  const getHistory = useCallback(() => {
    return messages;
  }, [messages]);

  const getRecentMessages = useCallback((count: number = 10) => {
    return messages.slice(-count);
  }, [messages]);

  return {
    messages,
    isProcessing,
    setIsProcessing,
    addMessage,
    clearHistory,
    getHistory,
    getRecentMessages,
  };
}
